import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import avatarIcon from '../../../assets/icons/avatar.svg'
import chatbotIcon from '../../../assets/icons/chatbot.svg'
import dashboardIcon from '../../../assets/icons/dashboard.svg'
import logoIcon from '../../../assets/icons/logo.svg'
import logoutIcon from '../../../assets/icons/logout.svg'
import missionIcon from '../../../assets/icons/mission.svg'
import { useUser } from '../../../contexts/User'
import { Sidebar } from '../../../elements/Sidebar'
import { getPaths, sideBarItemsPaths } from '../../../routing/routes'

import styles from './MainSidebar.module.scss'


export const MainSidebar = () => {
  const i18n = useTranslation()
  const navigate = useNavigate()
  const { handleLogout, userData } = useUser()
  const [showUserTitle, setShowUserTitle] = useState(false)


  return (
    <Sidebar
      cookieName='mainSidebarState'
      isActiveChecker={id => sideBarItemsPaths[id].some(path => location.pathname.includes(path))}
      fixed
      beforeTopItems={(
        <button
          className={styles.logoContainer}
          onClick={() => navigate(getPaths.managers._base)}
        >
          <img
            src={logoIcon}
            alt='sidebarLogo'
          />
        </button>
      )}
      itemsTop={[
        {
          permissionNeeded: 'missions_viewer',
          id: 'missions',
          icon: missionIcon,
          title: i18n.t('Common:Missions'),
          handler: () => navigate(getPaths.brands.missions.ongoing)
        },
        {
          permissionNeeded: 'dashboard_viewer',
          id: 'dashboard',
          icon: dashboardIcon,
          title: i18n.t('Common:Dashboard'),
          handler: () => navigate(getPaths.brands.dashboard.index)
        },
        {
          permissionNeeded: 'chatbot_user',
          id: 'chatbot',
          icon: chatbotIcon,
          title: i18n.t('Common:Chatbot'),
          handler: () => navigate(getPaths.brands.chatbot.index)
        }
      ]}
      beforeBottomItems={(
        <button
          className={styles.profile}
          onClick={() => setShowUserTitle(!showUserTitle)}
        >
          <img
            src={avatarIcon}
            alt='sidebarAvatar'
          />
          <div className={`${styles.managerInfo} ${showUserTitle && styles.showUserTitle}`}>
            <p>
              {userData?.name}
            </p>
            <span>
              {i18n.t('Template:Manager')}
            </span>
          </div>
        </button>
      )}
      itemsBottom={[
        {
          icon: logoutIcon,
          title: i18n.t('Template:Logout'),
          handler: handleLogout
        }
      ]}
    />
  )
}

